<template>
  <div class="card-header pb-2 d-flex justify-content-between align-items-center">
    <!-- 좌측: 정보 -->
    <div class="px-3 pt-3 pb-2 d-flex align-items-center">
      <div class="text-muted small" data-tour="dlist.total">
        총 <span class="total-num">{{ total.toLocaleString() }}</span>건
        <span class="mx-2">|</span>
        페이지당
        <select
          class="form-select form-select-sm d-inline-block ms-1"
          :value="pageSize"
          @change="$emit('update:pageSize', +$event.target.value)"
          style="width:auto; min-width: 4.5rem;"
        >
          <option v-for="s in pageSizes" :key="s" :value="s">{{ s }}</option>
        </select>
        건
      </div>
    </div>

    <!-- 우측: 검색 + 등록 버튼 -->
    <div class="ps-3 pt-3 pb-2 d-none d-xl-flex align-items-center gap-2" v-show="!isMobile">
      <!-- 🔎 검색 -->
      <div class="input-group input-group-sm tableinfobar-search" :style="{ width: searchWidth }" data-tour="dlist.search">
        <input
          type="text"
          class="form-control"
          :placeholder="searchPlaceholder"
          :value="query"
          @input="$emit('update:query', $event.target.value)"
          @keyup.enter="$emit('search')"
        />
        <button class="btn btn-outline-secondary mb-0" @click="$emit('search')">
          <i class="fa fa-search"></i>
        </button>
      </div>

      <!-- 등록 버튼 -->
      <soft-button
        v-if="createLabel"
        color="outline-success"
        class="ms-3"
        @click="$emit('create')"
        data-tour="dlist.create"
      >
        {{ createLabel }}
      </soft-button>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
  name: "TableInfoBar",
  components: { SoftButton },
  props: {
    total: { type: Number, required: true },
    pageSize: { type: Number, default: 10 },
    pageSizes: { type: Array, default: () => [5, 10, 20, 50] },
    createLabel: { type: String },

    query: { type: String, default: "" },                     // v-model:query
    searchPlaceholder: { type: String, default: "검색단어를 입력하세요" },
    searchWidth: { type: String, default: "280px" },          // 필요 시 조절
  },
  emits: ["update:pageSize", "create", "update:query", "search"],
  data(){ return { vw: window.innerWidth }; },
  computed:{ isMobile(){ return this.vw < 1200; } },
  mounted(){ window.addEventListener('resize', ()=>{ this.vw = window.innerWidth; }); },
  beforeUnmount(){ window.removeEventListener('resize', this._onResize); }
};
</script>

<style scoped>
.total-num {
  display: inline-block;
  min-width: 2ch;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* 인풋/버튼 높이 통일 */
.tableinfobar-search { --h: 38px; }
.tableinfobar-search .form-control {
  height: var(--h);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.tableinfobar-search .btn {
  height: var(--h);
  display: inline-flex;
  align-items: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid #d2d6da;
}
</style>
